import CompanyProfileDto from '@/models/Companies/CompanyProfileDto';
import LocationProfileDto from '@/models/Locations/LocationProfileDto';
import WorkerProfileDto from '@/models/Workers/WorkerProfileDto';
import BranchDto from '@/models/Branches/BranchDto';
import DeskDto from '@/models/Desks/DeskDto';
import TimesheetStatus from '@/models/Timesheets/TimesheetStatus';

export default class TimesheetSearchViewModel {
    status: TimesheetStatus;
    startAtFromTo: string[] = [];
    companies: CompanyProfileDto[] = [];
    selectedCompany: CompanyProfileDto;
    locations: LocationProfileDto[] = [];
    selectedLocation: LocationProfileDto;
    workers: WorkerProfileDto[] = [];
    selectedWorker: WorkerProfileDto;
    desks: DeskDto[] = [];
    selectedDesk: DeskDto;
    branches: BranchDto[] = [];
    selectedBranch: BranchDto;
}